import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import AppConfig from 'utils/app-config';
import RollbarService from './RollbarService';

class GambitService {
  generateVisitHash() {
    const timestamp = Date.now();
    const uuid = uuidv4();
    return `${timestamp}-${uuid}`;
  }

  translateEventParams(eventType, event) {
    return {
      interaction: {
        name: event?.name,
        visit_hash: event?.visitHash,
        interaction_type: event?.interactionType,
        properties: event?.properties || {},
      },
      visit: {
        base_user_id: event?.baseUserId,
        visit_hash: event?.visitHash,
        visitable_type: event?.visitableType,
        properties: event?.properties || {},
      },
    }[eventType];
  }

  validateEventParams(event, eventRequiredParams) {
    const isProduction = AppConfig.get('environment') === 'production';

    const validations = eventRequiredParams.map((eventRequiredParam) => {
      const hasRequiredParam = Boolean(event?.[eventRequiredParam]);

      if (!isProduction && !hasRequiredParam) {
        console.error(`${eventRequiredParam}Error`); // eslint-disable-line no-console
      }

      return hasRequiredParam;
    });

    return validations.every((validation) => validation === true);
  }

  trackVisit(visit) {
    const hasRequiredParams = this.validateEventParams(visit, ['baseUserId', 'visitableType', 'visitHash']);

    if (!hasRequiredParams) return;

    const translatedVisit = this.translateEventParams('visit', visit);

    this.trackEvent(translatedVisit, 'track');
  }

  trackInteraction(interaction) {
    const hasRequiredParams = this.validateEventParams(interaction, ['name', 'interactionType', 'visitHash']);

    if (!hasRequiredParams) return;

    const translatedInteraction = this.translateEventParams('interaction', interaction);

    this.trackEvent(translatedInteraction, 'interaction');
  }

  trackEvent(event, eventType) {
    if (!['production', 'test'].includes(AppConfig.get('environment'))) {
      console.info(event); // eslint-disable-line no-console
    }

    const trackingData = {
      ...event,
      event: eventType,
      system_code: process.env.QP_FRONT_SYS_CODE,
      ga_client_id: process.env.GOOGLE_ID,
    };

    axios.post(`${process.env.GAMBIT_API_HOST}/api/events`, trackingData).catch((e) => RollbarService.error(
      `[GAMBIT TRACKER ERROR]: ${e}`,
    ));
  }
}

export default new GambitService();
